import * as api from "@/api";
import makeListingMixin from "@lab/store/vuexListingMixin";

export default makeListingMixin(
	"listingShortlist",
	api.listingShortlist
)({
	state: {
		shortlist: [],
		criteria: {
			careneeds: [
				{
					value: "permanent",
					label: "Permanent care"
				},
				{
					value: "respite",
					label: "Respite care"
				},
				{
					value: "respitesecure",
					label: "Respite (secure dementia)"
				},
				{
					value: "dementiafriendly",
					label: "Dementia-friendly"
				},
				{
					value: "dementiasecure",
					label: "Secure dementia care"
				},
				{
					value: "subacute",
					label: "Sub-acute care"
				},
				{
					value: "bariatric",
					label: "Bariatric care"
				}
			],
			financials: [
				"Not yet known",
				"Self funded (RAD)",
				"Partial support",
				"Full support"
			]
		}
	},
	getters: {
		searchcritera: (state) => state.criteria
	}
});
